export default __webpack_public_path__ + "9f04cee8ca7cabbef8a2114d377fb658.png";